import { useEffect, useState } from 'react';
import { useField } from 'formik';
import TemplateIconOutlined from 'components/icons/TemplateIconOutlined';
import FormSectionHeader from 'components/new-ui/base/form/FormSectionHeader';
import ReadonlyFormItem from 'components/new-ui/base/form/ReadonlyFormItem';
import SearchBar from 'components/new-ui/base/searchbar/SearchBar';
import { useMultiStepFormContext } from 'components/new-ui/composed/multistep-form/MultiStepFormProvider';
import useGlobalOverlay from 'hooks/useGlobalOverlay';
import { getTemplates } from 'store/template/client';
import { TemplateResponse } from 'store/template/template';
import { MessageTypes } from 'store/declarations/enums/common/declaration-types';
import { useBrokerUploadContext } from '../BrokerUploadProvider';
import { BrokerUploadSteps } from '../types';

const stepKey = BrokerUploadSteps.TEMPLATE;
const fieldName = 'template.templateId';

const TemplateStep = () => {
    const [field, , helpers] = useField(fieldName);
    const [formTypeField] = useField('formType.formType');
    const { isActive, isComplete, isIdle, resetStep, stepsConfig } = useMultiStepFormContext<any>();
    const { country, type } = useBrokerUploadContext();
    const isPreSelected = stepsConfig.find((s: any) => s.key === stepKey)?.disabled ?? false;
    const { showGlobalOverlay, hideGlobalOverlay } = useGlobalOverlay();
    const [templates, setTemplates] = useState<TemplateResponse[]>([]);

    useEffect(() => {
        if (!country || !type || !formTypeField.value) return;

        showGlobalOverlay({ type: 'LoadingOverlay', payload: { message: 'Loading templates...' } });
        getTemplates(country, type, formTypeField.value as MessageTypes, { size: 200 })
            .then((payload) => setTemplates(payload.list))
            .finally(() => hideGlobalOverlay());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formTypeField.value]);

    const templateOptions = templates.map((t) => ({ value: t.id, label: t.templateName }));
    const selectedTemplate = templates.find((t) => t.id === field.value);
    const sectionTitle = 'Template (Optional)';

    if (isIdle(stepKey)) {
        return <FormSectionHeader title={sectionTitle} icon={<TemplateIconOutlined />} />;
    }

    if (isComplete(stepKey)) {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <FormSectionHeader title={sectionTitle} icon={<TemplateIconOutlined />} />
                <ReadonlyFormItem
                    disabled={isPreSelected}
                    value={selectedTemplate?.templateName}
                    onReset={() => resetStep(stepKey, 'templateId')}
                />
            </div>
        );
    }

    if (isActive(stepKey)) {
        if (isPreSelected) {
            return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <FormSectionHeader title={sectionTitle} icon={<TemplateIconOutlined />} />
                    <ReadonlyFormItem disabled={true} value={selectedTemplate?.templateName} />
                </div>
            );
        }

        return (
            <div>
                <FormSectionHeader title={sectionTitle} icon={<TemplateIconOutlined />} />
                <SearchBar
                    style={{ width: '100%', marginTop: 16 }}
                    inputPlaceholder="Select Template"
                    options={templateOptions}
                    onSelect={(val: string) => helpers.setValue(val)}
                    value={selectedTemplate?.templateName}
                />
            </div>
        );
    }

    return null;
};

export default TemplateStep;
